import script from "./match-3game.vue?vue&type=script&setup=true&lang=js"
export * from "./match-3game.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__